<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.71429 12L12 1.71429L22.2857 12"
      stroke="#A3A3A3"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4 9.71429V18.8572C4 19.1603 4.12041 19.4509 4.33474 19.6653C4.54906 19.8796 4.83975 20 5.14286 20H8.57143C8.87453 20 9.16522 19.8796 9.37955 19.6653C9.59388 19.4509 9.71429 19.1603 9.71429 18.8572V14.2857C9.71429 13.9826 9.83469 13.6919 10.049 13.4776C10.2633 13.2633 10.554 13.1429 10.8571 13.1429H13.1429C13.446 13.1429 13.7367 13.2633 13.951 13.4776C14.1653 13.6919 14.2857 13.9826 14.2857 14.2857V18.8572C14.2857 19.1603 14.4061 19.4509 14.6205 19.6653C14.8348 19.8796 15.1255 20 15.4286 20H18.8571C19.1602 20 19.4509 19.8796 19.6653 19.6653C19.8796 19.4509 20 19.1603 20 18.8572V9.71429"
      stroke="#A3A3A3"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
